var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMathflat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#F5F5F5",
    rx: 3.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_mathflat_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00D8FF",
    d: "M23.48 7.143c-2.357.487-9.206 1.86-10.496 2.127-.133.044-.222.133-.222.266v10.723S21.479 10.2 23.747 7.586c.134-.177-.044-.487-.267-.443z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#197FDB",
    d: "M12.85 21.233l6.672-7.71v14.18c0 .265-.311.354-.49.177-1.423-1.462-5.514-5.76-6.182-6.47-.088-.044-.088-.132 0-.177z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_mathflat_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12.143v22.143H0z",
    transform: "translate(12.143 6.429)"
  })))));
}
export default __webpack_public_path__ + "655de3ae027f72bf0c9c7433c2d86c14.svg";
export { SvgIconMathflat as ReactComponent };